import * as types from './project-members.types';
export const projectTeamsPageSelectors: types.IProjectTeamsPageSelectors = {
  selectProjectTeams: (state) => state.page.projectTeams.projectTeamsIds,
};
